import { ChevronLeft } from "@mui/icons-material";
import { Grid, Typography } from "@mui/material";
import { FC } from "react";

export const BackButton: FC<{ onClick: () => void }> = ({ onClick }) => {
  return (
    <>
      <Grid
        container
        alignContent="center"
        mt={1}
        sx={{ cursor: "pointer" }}
        onClick={onClick}
      >
        <Grid item>
          <ChevronLeft color="primary" />
        </Grid>
        <Grid item>
          <Typography color="primary">Back</Typography>
        </Grid>
      </Grid>
    </>
  );
};
